import './Trust.css';

const cards = [
  {
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
        <path d="M15 3L18.5 8H24L20 12L22 18L15 14.5L8 18L10 12L6 8H11.5L15 3Z" fill="white" opacity="0.2" stroke="white" strokeWidth="1.6" strokeLinejoin="round"/>
        <path d="M11 15l3 3 5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    badge: 'Yapay Zeka',
    title: 'Yapay Zeka Destekli Doğrulama',
    desc: 'Yüklenen her not, paylaşılmadan önce kalite, tutarlılık ve akademik uygunluk açısından yapay zeka sistemimiz tarafından incelenir.',
    color: '#5784E6',
  },
  {
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
        <path d="M15 4L24 8V15C24 20 19.5 24.5 15 26C10.5 24.5 6 20 6 15V8L15 4Z" fill="white" opacity="0.2" stroke="white" strokeWidth="1.6" strokeLinejoin="round"/>
        <path d="M11 15l3 3 5-5" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    badge: 'Moderasyon',
    title: 'Denetlenen İçerik',
    desc: 'Moderasyon sistemimiz, paylaşılan tüm içeriklerin uygun, yardımcı ve akademik açıdan değerli kalmasını sağlar.',
    color: '#7FA0ED',
  },
  {
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
        <circle cx="15" cy="15" r="10" fill="white" opacity="0.2" stroke="white" strokeWidth="1.6"/>
        <path d="M15 10v5l3 3" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    badge: 'Şikayet Et',
    title: 'Sorunları Bildir',
    desc: 'Öğrenciler yanlış, düşük kaliteli veya uygunsuz notları hızlı inceleme için kolayca bildirebilir.',
    color: '#5784E6',
  },
  {
    icon: (
      <svg width="30" height="30" viewBox="0 0 30 30" fill="none">
        <rect x="6" y="8" width="18" height="14" rx="4" fill="white" opacity="0.2" stroke="white" strokeWidth="1.6"/>
        <path d="M10 15l3 3 7-7" stroke="white" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
      </svg>
    ),
    badge: 'Kalite Önce',
    title: 'Kalite Odaklı Paylaşım',
    desc: 'NoteSwapp, miktardan çok kaliteyi ön plana çıkarır — öğrencilerin yalnızca iyi yapılandırılmış, güvenilir notlara erişmesini sağlar.',
    color: '#7FA0ED',
  },
];

export default function Trust() {
  return (
    <section className="trust">
      <div className="container">
        <div className="trust__tag">Güvenlik & Kalite</div>
        <h2 className="section-title trust__title">Güven ve kalite için tasarlandı</h2>
        <p className="section-subtitle trust__subtitle">
          NoteSwapp, yapay zeka destekli kontroller, moderasyon ve kullanıcı geri bildirimlerini bir araya getirerek daha güvenli ve güvenilir bir akademik not paylaşım deneyimi oluşturmayı hedefler.
        </p>

        <div className="trust__grid">
          {cards.map((card, i) => (
            <div className="trust__card" key={i} style={{ '--card-color': card.color }}>
              <div className="trust__icon-wrap" style={{ background: card.color }}>
                {card.icon}
              </div>
              <div className="trust__badge">{card.badge}</div>
              <h3 className="trust__card-title">{card.title}</h3>
              <p className="trust__card-desc">{card.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
